import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import IconButton from '@welldev-group/rcl-icon-button';
import './styles.scss';

const ExchangeCartSummaryAccordion = ({ header, children }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const handleAccordionToggle = () => {
    setIsAccordionOpen(prev => !prev);
  };

  return (
    <div className="d-flex-column row-gap-12">
      <div className="exchange-cart-summary-accordion d-flex align-center column-gap-12">
        <IconButton
          className="exchange-cart-summary-accordion__arrow-button"
          icon={<Icon name={isAccordionOpen ? 'iconUpChevron' : 'iconDownChevron'} size="tiny" />}
          onClick={handleAccordionToggle}
          padding="none"
          isIconOnly={true}
          color="default"
          size="xxs"
        />
        {header}
      </div>
      {isAccordionOpen && children}
    </div>
  );
};

ExchangeCartSummaryAccordion.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default ExchangeCartSummaryAccordion;
